
import React from "react";
import { Link } from "react-router-dom";
import BusinessType from "../../components/Business/BusinessTypeList/BusinessTypeList";


const BusinessTypeList = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Business Type List</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Business</li>
          <li>Business Type List</li>
        </ul>
      </div>
      <BusinessType/>
    </>
  );
};

export default BusinessTypeList;